const FREE_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
]);

function extractDomain(value) {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (trimmed.includes('@')) {
    const parts = trimmed.split('@');
    const domain = parts[parts.length - 1].toLowerCase().trim();
    return domain || null;
  }

  try {
    let hostname;
    if (trimmed.includes('://')) {
      hostname = new URL(trimmed).hostname;
    } else {
      hostname = new URL(`https://${trimmed}`).hostname;
    }
    hostname = hostname.toLowerCase().replace(/^www\./, '');
    return hostname || null;
  } catch (e) {
    return null;
  }
}

function isFreeEmailDomain(domain) {
  if (!domain || typeof domain !== 'string') return true;
  return FREE_EMAIL_DOMAINS.has(domain.toLowerCase().trim());
}

module.exports = { extractDomain, isFreeEmailDomain, FREE_EMAIL_DOMAINS };
